export const formatDate = (value: any, locale: string) => {
  const date = value?.toDate?.() || (value && new Date(value));

  if (!date || Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
};
